import { AIError } from '@distribute/shared/api-types/ai';

export const AI_ERROR_MAP = {
  [AIError.MODERATION_FAILED]: {
    title: 'Moderation Failed',
    description:
      "Sorry, your request didn't pass our moderation. Please revise your request.",
  },
  [AIError.TOO_LARGE_REQUEST]: {
    title: 'Request Too Large',
    description: 'Your request is too large. Please try with a smaller input.',
  },
  [AIError.JSON_PARSE_ERROR]: {
    title: 'Processing Error',
    description:
      'There was an error processing your request. Please try again.',
  },
  [AIError.INVALID_DATA_CONTENT]: {
    title: 'Processing Error',
    description:
      'There was an error processing your request. Please try again.',
  },
  [AIError.INVALID_DATA_CONTENT_ERROR]: {
    title: 'Processing Error',
    description:
      'There was an error processing your request. Please try again.',
  },
  [AIError.INVALID_RESPONSE_DATA_ERROR]: {
    title: 'Processing Error',
    description:
      'There was an error processing your request. Please try again.',
  },
  [AIError.NO_CONTENT_GENERATED_ERROR]: {
    title: 'Generation Failed',
    description: 'We were unable to generate a response. Please try again.',
  },
  [AIError.EMPTY_RESPONSE_BODY_ERROR]: {
    title: 'Generation Failed',
    description: 'We were unable to generate a response. Please try again.',
  },
  [AIError.OVERLOADED_ERROR]: {
    title: 'Service Overloaded',
    description:
      'Our service is currently experiencing high demand. Please try again in a moment.',
  },
  default: {
    title: 'AI Service Error',
    description:
      'The AI service encountered an unexpected error. Please try again.',
  },
};
